export const galleryTour = [
  { target: '.tour-gallery', content: 'This is your gallery. Here you can see all the images you have generated or uploaded.', placement: 'center' },
];